import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import View from '../view';
import Cell, { ICellProps } from '../cell';

interface IFieldProps extends Omit<ICellProps, 'label' | 'title' | 'value' | 'renderTitle' | 'renderLabel' | 'renderValue'> {
  /**
   * 自定义输入框 label 标签
   */
  label?: string;
  /**
   * 右侧内容对齐方式
   * @default left
   */
  bodyAlign?: 'left' | 'right' | 'center';
  /**
   * 错误提示文案
   */
  errorMessage?: string;
}

const Field: FC<PropsWithChildren<IFieldProps>> = ({ children, className, label, icon, center, bodyAlign = 'left', errorMessage, ...restProps }) => {
  const rootCls = classNames('ink-field', className);
  const bodyCls = classNames('ink-field__body', {
    [`ink-field__body--${bodyAlign}`]: bodyAlign,
  });

  return (
    <Cell
      {...restProps}
      icon={icon}
      title={label}
      center={center}
      className={rootCls}
      renderValue={() => (
        <View className={bodyCls}>
          {children}
          {errorMessage && <View className="ink-field__error">{errorMessage}</View>}
        </View>
      )}
    />
  );
};

export default Field;
